"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrCaUsd = exports.FrCaCad = exports.EnCaUsd = exports.EnCaCad = void 0;
class EnCaCad {
    constructor() {
        this.locale = "en-ca";
        this.dateFormat = {
            short: "MM/dd/yyyy",
            medium: "MMMM dd, yyyy",
            long: "MMMM d, yyyy",
        };
        this.currencyFormat = {
            code: "CAD",
            symbol: "$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "Cn",
            negativePattern: "-C n"
        };
    }
}
exports.EnCaCad = EnCaCad;
class EnCaUsd {
    constructor() {
        this.locale = "en-ca";
        this.dateFormat = {
            short: "MM/dd/yyyy",
            medium: "MMMM dd, yyyy",
            long: "MMMM d, yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "Cn",
            negativePattern: "-C n"
        };
    }
}
exports.EnCaUsd = EnCaUsd;
class FrCaCad {
    constructor() {
        this.locale = "fr-ca";
        this.dateFormat = {
            short: "MM/dd/yyyy",
            medium: "MMMM dd, yyyy",
            long: "d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "CAD",
            symbol: "$",
            decimalSeparator: ",",
            groupSeparator: " ",
            positivePattern: "Cn",
            negativePattern: "-C n"
        };
    }
}
exports.FrCaCad = FrCaCad;
class FrCaUsd {
    constructor() {
        this.locale = "fr-ca";
        this.dateFormat = {
            short: "MM/dd/yyyy",
            medium: "MMMM dd, yyyy",
            long: "d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ",",
            groupSeparator: " ",
            positivePattern: "Cn",
            negativePattern: "-C n"
        };
    }
}
exports.FrCaUsd = FrCaUsd;
